class ShopTypesServ {
    constructor() {
        this.context = {
            shops: 'shops',
            orangemoney: 'orangemoney'
        };
        this.types = {
            shop: {
                id: 'shop'
            },
            tkrShop: {
                id: 'tkrShop'
            },
            store: {
                id: 'store'
            },
            smartStore: {
                id: 'smartStore'
            },
            strategic: {
                id: 'strategic'
            },
            dealer: {
                id: 'dealer'
            },
            omMerchant: {
                id: 'omMerchant',
                subTypes: {
                    fashion: 'Moda',
                    supermarket: 'Supermarket',
                    restaurants: 'Restaurante',
                    freeTime: 'Timp liber',
                    health: 'Sanatate',
                    services: 'Servicii',
                    electronics: 'Electronice',
                    market: 'Magazin',
                    otherPartners: 'altiParteneri'
                }
            }
        };
    }

    getContextShops() {
        return this.context.shops;
    }

    getContextOrangeMoney() {
        return this.context.orangemoney;
    }

    getTypeShop() {
        return this.types.shop.id;
    }

    getTypeStore() {
        return this.types.store.id;
    }

    getTypeTkr() {
        return this.types.tkrShop.id;
    }

    getTypeSmartStore() {
        return this.types.smartStore.id;
    }

    getTypeStrategic() {
        return this.types.strategic.id;
    }

    getTypeDealer() {
        return this.types.dealer.id;
    }

    getTypeOmMerchant() {
        return this.types.omMerchant.id;
    }

    getSubTypeFashion() {
        return this.types.omMerchant.subTypes.fashion;
    }

    getSubTypeSupermarket() {
        return this.types.omMerchant.subTypes.supermarket;
    }

    getSubTypeRestaurants() {
        return this.types.omMerchant.subTypes.restaurants;
    }

    getSubTypeFreeTime() {
        return this.types.omMerchant.subTypes.freeTime;
    }

    getSubTypeHealth() {
        return this.types.omMerchant.subTypes.health;
    }

    getSubTypeServices() {
        return this.types.omMerchant.subTypes.services;
    }

    getSubTypeElectronics() {
        return this.types.omMerchant.subTypes.electronics;
    }

    getSubTypeMarket() {
        return this.types.omMerchant.subTypes.market;
    }

    getSubTypeOtherPartners() {
        return this.types.omMerchant.subTypes.otherPartners;
    }

    isOrangeShop(type) {
        const shops = [this.getTypeShop(), this.getTypeStore(), this.getTypeSmartStore(), this.getTypeStrategic(), this.getTypeDealer(), this.getTypeTkr()];
        return shops.indexOf(type) > -1;
    }

    getTypesAndSubTypes() {
        return [
            this.getTypeShop(),
            this.getTypeStore(),
            this.getTypeSmartStore(),
            this.getTypeStrategic(),
            this.getTypeDealer(),
            this.getTypeTkr(),
            this.getTypeOmMerchant(),
            this.getSubTypeFashion(),
            this.getSubTypeSupermarket(),
            this.getSubTypeRestaurants(),
            this.getSubTypeFreeTime(),
            this.getSubTypeHealth(),
            this.getSubTypeServices(),
            this.getSubTypeElectronics(),
            this.getSubTypeMarket(),
            this.getSubTypeOtherPartners()
        ];
    }
}

export default ShopTypesServ;
